import type { MachineLayout, StateMachine } from "@pixelpuf/schemas/pxpf";
import { frameRange, type StateFrameRanges } from "@pixelpuf/schemas/state";

/**
 * Default machine seeded into new projects. The six-state idle/wait/walk/run/attack/die
 * skeleton is the historical PixelPuf default — kept as a starter template, no longer
 * authoritative. Users can rename/delete/replace any of these via the editor.
 */
export const STARTER_MACHINE: StateMachine = {
  initial: "idle",
  states: [
    { id: "idle" },
    { id: "wait" },
    { id: "walk" },
    { id: "run" },
    { id: "attack" },
    { id: "die" },
  ],
  transitions: [
    { from: "idle", to: "wait", event: "NEXT", trigger: "manual" },
    { from: "wait", to: "idle", event: "NEXT", trigger: "manual" },
    { from: "walk", to: "run", event: "NEXT", trigger: "manual" },
    { from: "run", to: "attack", event: "NEXT", trigger: "manual" },
    { from: "attack", to: "die", event: "NEXT", trigger: "manual" },
    { from: "die", to: "idle", event: "NEXT", trigger: "manual" },
  ],
};

/** xyflow positions seeded for the starter machine. Used as MachineLayout when fresh. */
export const STARTER_LAYOUT: MachineLayout = {
  idle: { x: 80, y: 200 },
  wait: { x: 320, y: 80 },
  walk: { x: 320, y: 320 },
  run: { x: 580, y: 200 },
  attack: { x: 820, y: 80 },
  die: { x: 820, y: 320 },
};

/** Default frame ranges per starter state — all collapsed to [0,0] until the user sets them. */
export const STARTER_STATE_FRAMES: StateFrameRanges = {
  idle: frameRange(0, 0),
  wait: frameRange(0, 0),
  walk: frameRange(0, 0),
  run: frameRange(0, 0),
  attack: frameRange(0, 0),
  die: frameRange(0, 0),
};

/** xyflow node default size. Used by `flow.ts` when building VisualGraphs. */
export const NODE_WIDTH = 120;
export const NODE_HEIGHT = 60;
